import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../settings/settings.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

 
@Component({
    selector: 'dialog-input',
    templateUrl: './dialog-input.html',
    styleUrls: ['./dialog-input.less'],
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule
    ]
})

export class InputDialog implements OnInit {


title:string="Loading Title";
subtitle:string="Vista Previa";
mensajeprincipal:string="";
mensajenegrita:string="";
error_array:any=[]
icon:string="autorenew";
coloricon:string="#ff4081";
boton_text:string="aceptar"
boton_confirm:boolean=false
colorBoton:string="#4ad991"


constructor(public snackBar: MatSnackBar,
public dialog: MatDialog,
public settings: SettingsService,
public dialogRef:MatDialogRef<InputDialog>) {


}


ngOnInit(){
    setTimeout(()=>{                         
       this.dialogRef.close(true)
   }, 100000);
}

close_dialog(){
    this.dialogRef.close(true)
}

confirmButton(){
    this.dialogRef.close(true)
}



}//endclass
